import { render, staticRenderFns } from "./device-list.vue?vue&type=template&id=04dc5c16&scoped=true"
import script from "./device-list.vue?vue&type=script&lang=js"
export * from "./device-list.vue?vue&type=script&lang=js"
import style0 from "./device-list.vue?vue&type=style&index=0&id=04dc5c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dc5c16",
  null
  
)

export default component.exports